'use client';

import { CustomImage as Image } from '..';
import styles from './Hero.module.css';

export const Hero = ({ handleCtaClick }: { handleCtaClick: () => void }) => {
  return (
    <div className={styles.root}>
      <div className={styles.content}>
        <h2>Ultrahuman products are HSA/FSA eligible with Flex</h2>
        <p>
          Save more with your pre-tax dollars. The Ring PRO, M1, Home, Photon
          and Voyager Charger are all HSA/FSA eligible.
        </p>
        <button onClick={handleCtaClick}>Explore now</button>
      </div>
      <div className={styles.imageContainer}>
        {/* Both crops render (lazy — hidden one never fetches); CSS picks
            one at 700px so SSR HTML is width-correct. */}
        <Image
          className="img-desktop"
          src="web_v2/hsa-fsa/hero/ecosystem-asset-desktop-new.png"
          width={3717}
          height={1688}
          alt="Ultrahuman HSA/FSA eligible products including Ring PRO"
          layout="responsive"
        />
        <Image
          className="img-mobile"
          src="web_v2/hsa-fsa/hero/ecosystem-asset-mobile-new.png"
          width={3717}
          height={1688}
          alt="Ultrahuman HSA/FSA eligible products including Ring PRO"
          layout="responsive"
        />
      </div>
    </div>
  );
};
